import {Circle} from "rc-progress";
import React from "react";
import {getAdvancementColor} from "../../utils/utils";

export const  CircularProgressBar = (advancement) => {

    //TODO create our own circular progress bar ?
    return (
        <div id="circular-progress-bar">
            <div>
                <Circle percent={advancement} strokeWidth="8" trailWidth="8" strokeColor={getAdvancementColor(advancement)} />
                <h4> {advancement}% </h4>
            </div>
        </div>
    )
}
